module.exports = __webpack_public_path__ + "img/logo.2ac675a4.png";